import { useQuery } from '@tanstack/react-query'
import { getGames } from '@/api/map/game'
import { keys } from '@/api/hooks/shared/keys'

/** Lab `Game/getGames` — products enabled for the signed-in agent. */
export function useGames() {
  return useQuery({
    queryKey: keys.games,
    queryFn: getGames,
    staleTime: 60_000,
  })
}
